import { atom, selector } from "recoil";
import { EcoClient, Env, RouteConfig } from "@eco/client";
import { EcoRoute, StaticRouteMappings } from "types";
import { createEcoClient, mapRouteConfigs, TranslationMap } from "utils";
import {quizTranslationState} from "components/quiz-form/states/quizState"

/**
 * 
 * Recoil selector to get an EcoClient instance with CSRF token set if any
 * 
 */
export const ecoClientState = selector<EcoClient>({
    key: 'state.EcoClient',
    get : async ({get}) => {
        // atom that, when the number value change (randomly), trigger runtimeEnv async request
        get(runtimeEnvForceReloadFlag)
        const ecoClient = createEcoClient() ;
        await ecoClient.loadAuth();
        return ecoClient ;
    }
});

export const routesAtoms = atom<RouteConfig[] | undefined>({
    key: 'state.Routes.atom',
    default : undefined
});

/**
 * 
 * Recoil selector holding application react-router routes initiliazed from
 * backend and computed based on app static routes
 * 
 */
export const routesState = selector<EcoRoute[]>({
    key: 'state.Routes',
    get : async ({get}) => {

        // get static routes mappings
        const _staticRouteMappings: StaticRouteMappings = get<StaticRouteMappings>(staticRouteMappingsState) ;

        const offlineRoutes = get(routesAtoms)
        if (offlineRoutes) {
            return mapRouteConfigs(offlineRoutes, _staticRouteMappings )
        }
        
        // get ecoClient 
        const ecoClient: EcoClient = get<EcoClient>(ecoClientState) ;

        // load routes configiguration from backend
        const routeConfigs = ecoClient ? await ecoClient.loadRouteConfigs() : [] ;
        
        // build react-router configuration from backend routes and app static routes
        const routes = mapRouteConfigs(routeConfigs, _staticRouteMappings ) ;
    
        return routes;
    }
});



/**
 * 
 * TODOC
 * 
 */
 export const staticRouteMappingsState = atom<StaticRouteMappings>({
    key: 'state.staticRouteMappings',
    default : {}
});


export const runtimeEnvForceReloadFlag = atom<number>({
    key: 'state.runtimeEnv.reload.flag',
    default: 0
})


/**
 * 
 * Recoil state holding app runtime env from backend
 * @deprected Since fetch of auth data is systematic, this recoil is now useless
 */
 export const runtimeEnvState = selector<Env | null>({
    key: 'state.runtimeEnv',
    get : async ({get}) => {
        const ecoClient: EcoClient  = get<EcoClient>(ecoClientState);
        // load runtime environment
        const env = ecoClient ? await ecoClient.loadEnv() : null ;
        return env;
    }
});


/**
 * 
 * Recoil state holding app 
 * 
 */
 export const translationsState = selector<TranslationMap>({
    key: 'state.translationsState',
    get: async ({ get }) => {
        const ecoClient: EcoClient  = get<EcoClient>(ecoClientState);

        // cannot load translations if not authenticated 
        if(!ecoClient.isAuthenticated() && process.env.REACT_APP_ECO_APP_NAME != 'medical-device' ){
            return new TranslationMap([]);
        }

        const response = process.env.REACT_APP_ECO_APP_NAME != 'medical-device' ?
             await ecoClient.loadTranslations() : get(quizTranslationState) 
        // currently all resources are loaded whatever 
        // app name is, so let's filter on prefix
        // res = res.filter((t) => t.key.startsWith("SDS1Click."));
        const trads = new TranslationMap(response) ;
        console.log("translations loaded");
        trads.setLoaded();
        return trads
    }
 })

/**
 * 
 * Recoil state holding app 
 * 
 */
export const customOptionState = selector<TranslationMap>({
    key: 'state.customOptionState',
    get: async ({ get }) => {
        const ecoClient: EcoClient  = get<EcoClient>(ecoClientState);

        // cannot load translations if not authenticated 
        if(!ecoClient.isAuthenticated()){
            return new TranslationMap([]);
        }

        const response = await ecoClient.loadTranslations()
        // currently all resources are loaded whatever 
        // app name is, so let's filter on prefix
        // res = res.filter((t) => t.key.startsWith("SDS1Click."));
        const customOption = new TranslationMap(response) ;
        console.log("customoption loaded");
        customOption.setLoaded();
        return customOption
    }
})
